module.exports = __webpack_public_path__ + "img/pamprin_multi_symptom_caplets.7fd0b3f0.jpg";